module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    class: {
      'selected': _vm.selected
    }
  }, [(_vm.canDestroy) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, null) > -1 : (_vm.selected)
    },
    on: {
      "change": function($event) {
        _vm.toggleTag()
      },
      "__c": function($event) {
        var $$a = _vm.selected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.selected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selected = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', _vm._l((_vm.tag), function(t) {
    return _c('div', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(t.name))])
  })), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tag[0].author.username))]), _vm._v(" "), _c('td', [(_vm.tag[0].image_id === '') ? _c('span', [_vm._v("-")]) : _c('span', {
    attrs: {
      "title": _vm.prettyFormatID
    }
  }, [_vm._v("\n      " + _vm._s(_vm.shortFormatID) + "\n    ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tag[0].updated_at))]), _vm._v(" "), (_vm.securityEnabled) ? _c('td', [_c('a', {
    attrs: {
      "href": _vm.tagLink
    }
  }, [_vm._v("\n      " + _vm._s(_vm.vulns) + " vulnerabilities\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/template-compiler?{"id":"data-v-f9640810"}!/home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/selector.js?type=template&index=0!./modules/repositories/components/tags-table-row.vue
// module id = 87
// module chunks = 0